import * as buildUrl from 'build-url'


export class UrlObj{
  url:string
  queryParams:any

  constructor(url="", queryParams = {}) {
    this.url = url
    this.queryParams = queryParams
  }

  toString(){

    let ris = buildUrl(this.url, {
      queryParams:this.queryParams
    });

    if(ris.endsWith("?")) ris = ris.slice(0, ris.length-1);

    return ris
  }
}
